import { render, staticRenderFns } from "./TemplateMessageList.vue?vue&type=template&id=25b50290&scoped=true"
import script from "./TemplateMessageList.vue?vue&type=script&lang=js"
export * from "./TemplateMessageList.vue?vue&type=script&lang=js"
import style0 from "./TemplateMessageList.vue?vue&type=style&index=0&id=25b50290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b50290",
  null
  
)

export default component.exports